
export const laneConfigFormValueDft = {
    laneName: undefined,
    labelSelectorKey: undefined,
    labelSelectorValue: undefined,
    serviceList: [],
};
